import React, { useEffect, useState } from 'react';
import { message } from 'antd';

import ChooseTime from './components/chooseTime';
import RowTable from './components/rowTable';
import LineChart from './components/lineChart';
import PieChart from './components/pieChart';
import { fundIndicator } from '@/services/chartData';
const FundData = () => {
  const [rowTableData1, setRowTableData1] = useState([]);
  const [rowTableData2, setRowTableData2] = useState([]);

  const [pieData1, setPieData1] = useState([]);
  const [pieData2, setPieData2] = useState([]);

  const [lineData1, setLineData1] = useState([]);
  const [lineData2, setLineData2] = useState([]);

  const [timeRadioValue, setTimeRadioValue] = useState('month');
  const [timeRangeValue, setTimeRangeValue] = useState(['', '']);
  const queryFundData = () => {
    let requestData = {};
    if (timeRadioValue === 'date') {
      requestData = {
        startDate: timeRangeValue[0],
        endDate: timeRangeValue[1],
      };
    } else {
      requestData = {
        quickQuery: timeRadioValue,
      };
    }
    fundIndicator({
      requestData: requestData,
    }).then(({ code, msg, data }) => {
      if (code === '00000') {
        setDatas(data);
      } else {
        message.error(msg);
      }
    });
  };
  const setDatas = (data) => {
    setRowTableData1([
      {
        title: '总收入',
        value: data.totalIncome,
        isTailDivider: true,
      },
      {
        title: '一部',
        value: data.department1Income,
        isTailDivider: true,
      },
      {
        title: '二部',
        value: data.department2Income,
        isTailDivider: true,
      },
      {
        title: '三部',
        value: data.department3Income,
      },
    ]);
    setPieData1([
      {
        title: '业务一部',
        value: Number(data.department1Income),
      },
      {
        title: '业务二部',
        value: Number(data.department2Income),
      },
      {
        title: '业务三部',
        value: Number(data.department3Income),
      },
    ]);
    let arr1 = [];
    arr1 = arr1
      .concat(
        data.department1IncomeTrend.map((i) => {
          return {
            ...i,
            category: '业务一部',
          };
        }),
      )
      .concat(
        data.department2IncomeTrend.map((i) => {
          return {
            ...i,
            category: '业务二部',
          };
        }),
      )
      .concat(
        data.department3IncomeTrend.map((i) => {
          return {
            ...i,
            category: '业务三部',
          };
        }),
      );
    setLineData1(arr1);

    setRowTableData2([
      {
        title: '总支出',
        value: data.totalExpenses,
        isTailDivider: true,
      },
      {
        title: '教练结算',
        value: data.merchantSettlement,
        isTailDivider: true,
      },
      {
        title: '渠道结算',
        value: data.partnerSettlement,
      },
    ]);
    setPieData2([
      {
        title: '教练结算',
        value: Number(data.merchantSettlement),
      },
      {
        title: '渠道结算',
        value: Number(data.partnerSettlement),
      },
    ]);
    let arr2 = [];
    arr2 = arr2.concat(
      data.merchantSettlementTrend.map((i) => {
        return {
          ...i,
          category: '教练结算',
        };
      }),
    );
    setLineData2(arr2);
  };
  useEffect(() => {
    queryFundData();
  }, [timeRadioValue, timeRangeValue]);
  const handleTimeChange = (type, value) => {
    if (type === 'date' && value) {
      setTimeRangeValue(value);
    }
    setTimeRadioValue(type);
  };
  return (
    <div>
      <ChooseTime
        timeRadioValue={timeRadioValue}
        onTimeChange={handleTimeChange}
      />
      <RowTable rowTableData={rowTableData1} title="资金账户-收入" />
      <PieChart pieData={pieData1} />
      <LineChart
        lineData={lineData1}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
      <br />
      <RowTable
        rowTableData={rowTableData2}
        title="资金账户-支出"
        style={{ marginTop: '40px' }}
      />
      <PieChart pieData={pieData2} />
      <LineChart
        lineData={lineData2}
        xField="abscissa"
        yField="ordinate"
        seriesField="category"
      />
    </div>
  );
};

export default FundData;
